// TODO liberar novos menus
export const menus = [
  { label: 'Produtos no endereço', path: '/basic-queries/address-info' },
  { label: 'Estoque de Produto', path: '/basic-queries/product-info' },
  { label: 'Informações do Lote', path: '/basic-queries/batch-info' },
  // { label: 'Movimentações do Produto', path: '/basic-queries' },
]
